// extracted by mini-css-extract-plugin
module.exports = {"container":"ModalWrap_container__b8OHO","backdrop":"ModalWrap_backdrop__1pT4m"};